export function adapterMapper<Source, Mapped>(
  source: Source,
  mappings: Record<keyof Source, keyof Mapped>,
) {
  const target: Partial<Mapped> = {} as Mapped

  for (const sourceKey in mappings) {
    if (Object.prototype.hasOwnProperty.call(source, sourceKey)) {
      const targetKey = mappings[sourceKey]
      target[targetKey] = source[
        sourceKey
      ] as unknown as Mapped[typeof targetKey]
    }
  }

  return target as Mapped
}
